import { useState, useContext } from "react"
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Typography,
  Divider,
  IconButton
} from "@mui/material";
import "../../../Style/dialogstyle.scss"
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import {SelectProvincailCouncilInMandate} from "../../Include/DynamicSelect";
import { AuthContext } from "../../../Context/AuthContext";
import SecretaryItem from "./SecretaryItem"



export default function SecretaryList ({newSecretary, secretaryList, setSecretaryList, viewOnly}){
   
    // Change Language
    const { t, setAlert } = useContext(AuthContext);

    // Function to add a new item to the list
    const handleAddItem = () => {
        setSecretaryList((prev) => [...prev, newSecretary]);
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Stack direction={"row"} justifyContent={"space-between"}>
                    <Stack 
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Typography className={t("class-name-field-title")}>
                            {t("thead_secretary")}
                        </Typography>
                    </Stack>

                    <IconButton onClick={handleAddItem} disabled={viewOnly}>
                        <AddBoxIcon 
                            fontSize="medium"
                            sx={{ color: viewOnly ? "gray" : "green", cursor: "pointer" }} 
                        />
                    </IconButton>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Stack direction={"column"} spacing={0.5}>
                    {
                        secretaryList?.map((elem, index) => (
                            <SecretaryItem 
                                viewOnly={viewOnly}
                                elem={elem}
                                index={index}
                                secretaryList={secretaryList}
                                setSecretaryList={setSecretaryList}
                            />  
                        ))
                    }
                </Stack>
            </Grid>
        </Grid>
      
    )
}